export default "__VITE_ASSET__wjLY7pKE__"